import uri from "flow/utils/uri";

export default uri.getBaseUrl();
